// extracted by mini-css-extract-plugin
export default {"footer":"f41384672006","links":"f60719517b2b","copyright":"a28db6ae694f","build":"a6bb9c869d38"};